(() => {
  if (window.ysPlanComparisonInstalled) return;
  window.ysPlanComparisonInstalled = true;

  const sources = [...document.querySelectorAll('.yogaspace-product-main [data-ys-plan-price][data-variant-id]')];
  if (!sources.length) return;

  const syncPrice = (source) => {
    const variantId = source.dataset.variantId;
    if (!variantId) return;
    document.querySelectorAll(`[data-ys-comparison-price="${CSS.escape(variantId)}"]`).forEach((target) => {
      target.textContent = source.textContent.trim();
    });
  };

  sources.forEach((source) => {
    syncPrice(source);
    new MutationObserver(() => syncPrice(source)).observe(source, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });
})();
